import { Stack, styled } from '@mui/material';

export const DescriptionInner = styled(Stack)`
  flex-direction: column;
  gap: 12px;
  h2 {
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    color: var(--dk-text, black);
  }
  p {
    margin: 0 0 0 6px;
    font-weight: 400;
    font-size: 14px;
    color: var(--dk-text-secondary, #888d96);
  }
`;
